export default __webpack_public_path__ + "static/media/640_dummy2016-physiotherapie01-de.8917d637.png";